
import {
	Model,
	IModelAttributes,
	attribute,
	entity,
} from 'Models/Model';
import * as Models from 'Models/Entities';
import { IAcl } from '../Security/IAcl';
import { observable } from 'mobx';
import UserMonitoredcustomersmanytomany from '../Security/Acl/UserMonitoredcustomersmanytomany';
import VisitorsMonitoredcustomersmanytomany from '../Security/Acl/VisitorsMonitoredcustomersmanytomany';


export interface IMonitoredsCustomersAttributes extends IModelAttributes {
	monitoredsId: string;
	customersId: string;

	monitoreds: Models.MonitoredEntity | Models.IMonitoredEntityAttributes;
	customers: Models.CustomerEntity | Models.ICustomerEntityAttributes;

}

@entity('MonitoredsCustomers')
export default class MonitoredsCustomers
	extends Model
	implements IMonitoredsCustomersAttributes {
	public static acls: IAcl[] = [
		new UserMonitoredcustomersmanytomany(),
		new VisitorsMonitoredcustomersmanytomany(),

	];

	@observable
	@attribute()
	public monitoredsId: string;

	@observable
	@attribute()
	public customersId: string;

	@observable
	@attribute({ isReference: true })
	public monitoreds: Models.MonitoredEntity;

	@observable
	@attribute({ isReference: true })
	public customers: Models.CustomerEntity;


	constructor(attributes?: Partial<IMonitoredsCustomersAttributes>) {

		super(attributes);

		if (attributes) {
			if (attributes.monitoredsId) {
				this.monitoredsId = attributes.monitoredsId;
			}
			if (attributes.customersId) {
				this.customersId = attributes.customersId;
			}

			if (attributes.monitoreds) {
				if (attributes.monitoreds instanceof Models.MonitoredEntity) {
					this.monitoreds = attributes.monitoreds;
					this.monitoredsId = attributes.monitoreds.id;
				} else {
					this.monitoreds = new Models.MonitoredEntity(attributes.monitoreds);
					this.monitoredsId = this.monitoreds.id;
				}
			} else if (attributes.monitoredsId !== undefined) {
				this.monitoredsId = attributes.monitoredsId;
			}

			if (attributes.customers) {
				if (attributes.customers instanceof Models.CustomerEntity) {
					this.customers = attributes.customers;
					this.customersId = attributes.customers.id;
				} else {
					this.customers = new Models.CustomerEntity(attributes.customers);
					this.customersId = this.customers.id;
				}
			} else if (attributes.customersId !== undefined) {
				this.customersId = attributes.customersId;
			}
		}

	}


}
